import { List } from "immutable";

export default {
  SET_FEATURES(state, features) {
    state.features = List(features);
  },
  RESET_STATE (state, data) {
    Object.assign(state, data)
  },
}
